import styled, { css } from 'styled-components';

import { selfOrFunction } from '../../utils';

import { CardProps } from './types';

export const CardContainer = styled.div<CardProps>`
  border-radius: ${({ theme, borderRadius }) => theme.mosaiq.spacing(borderRadius ?? 1.5)}px;
  background-color: ${(props) =>
    selfOrFunction(props, props.backgroundColor) ?? props.theme.mosaiq.colors.grey};
  max-width: ${({ theme, maxWidth }) =>
    typeof maxWidth === 'number'
      ? `${theme.mosaiq.spacing(maxWidth)}px`
      : typeof maxWidth === 'string'
      ? maxWidth
      : undefined};
  min-width: ${({ theme, minWidth }) =>
    typeof minWidth === 'number'
      ? `${theme.mosaiq.spacing(minWidth)}px`
      : typeof minWidth === 'string'
      ? minWidth
      : undefined};
  transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;

  ${(props) =>
    props.border &&
    css`
      border: thin ${props.borderStyle || 'solid'}
        ${props.borderColor
          ? selfOrFunction(props, props.borderColor)
          : props.theme.mosaiq.colors.grey60};
    `}

  ${(props) =>
    (!!props.hoverBackgroundColor || !!props.hoverBorderColor) &&
    css`
      &:hover {
        background-color: ${!!props.hoverBackgroundColor
          ? selfOrFunction(props, props.hoverBackgroundColor)
          : undefined};
        ${props.border &&
        css`
          border: thin ${props.borderStyle || 'solid'}
            ${props.hoverBorderColor ? selfOrFunction(props, props.hoverBorderColor) : undefined};
        `}
      }
    `}

  ${(props) =>
    (!!props.activeBackgroundColor || !!props.activeBorderColor) &&
    css`
      &:active {
        background-color: ${!!props.activeBackgroundColor
          ? selfOrFunction(props, props.activeBackgroundColor)
          : undefined};
        ${props.border &&
        css`
          border: thin ${props.borderStyle || 'solid'}
            ${props.activeBorderColor ? selfOrFunction(props, props.activeBorderColor) : undefined};
        `}
      }
    `}
`;
